var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"select-wrapper",on:{"click":function($event){$event.stopPropagation();_vm.showOptions = true}}},[_c('div',{ref:"select"},[_vm._t("select")],2),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.lastShow),expression:"lastShow"}],staticClass:"options",style:(_vm.styles)},[_vm._t("options")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }